/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogic1,
  ManagerLogic1Interface,
} from "../../../contracts/manager/ManagerLogic1";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "ticketId",
        type: "bytes32",
      },
    ],
    name: "TicketWithdraw",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "otcTicketId",
        type: "uint256",
      },
    ],
    name: "cancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "domainSeparator",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLastPriceUsdtForPpe",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "ticketId",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "status",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "makerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "makerTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cancelTimestamp",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "takerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "takerTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.OTCPurchaseTicket",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "ticketId",
        type: "bytes32",
      },
    ],
    name: "getTicketId",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "listMakerUsdtForPpe",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "ticketId",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "status",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "makerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "makerTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cancelTimestamp",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "takerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "takerTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.OTCPurchaseTicket[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "listTakerUsdtForPpe",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "ticketId",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "status",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "makerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "makerTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cancelTimestamp",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "takerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "takerTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.OTCPurchaseTicket[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "makerVolume",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "takerVolume",
        type: "uint256",
      },
    ],
    name: "makeUsdtForPpe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "orderBookUsdtForPpe",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "ticketId",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "status",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "address",
            name: "makerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "makerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "makerTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cancelTimestamp",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
          {
            internalType: "address",
            name: "takerToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "takerVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "takerTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.OTCPurchaseTicket[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "otcTicketId",
        type: "uint256",
      },
    ],
    name: "take",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogic1ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogic1ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogic1__factory extends ContractFactory {
  constructor(...args: ManagerLogic1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogic1> {
    return super.deploy(overrides || {}) as Promise<ManagerLogic1>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogic1 {
    return super.attach(address) as ManagerLogic1;
  }
  override connect(signer: Signer): ManagerLogic1__factory {
    return super.connect(signer) as ManagerLogic1__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogic1Interface {
    return new utils.Interface(_abi) as ManagerLogic1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogic1 {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogic1;
  }
}
